<div [ngClass]="{'padding-all': isPadded}">
  <ng-container>
    @if (componentLabel != null && componentLabel.length > 0) {
      <div class="text-align-left">
        {{componentLabel}}
      </div>
    }
    <div class="file-upload text-align-center">
      <div #fileUploadLabel [ngClass]="{'drop-active': hasFilesToDrop }" [ngStyle]="{ 'display': (allowUpload) ? 'inherit': 'none' }" (dragover)="onDragOver($event)" (drop)="onDrop($event)" (dragleave)="onDragLeave($event)" class="drop-area">
        <div class="padding-all text-align-center">
          <span class="upload-text-container">
            <svg-icon title="File Upload" icon="icon-upload" class="small dark-gray minor-margin-right" aria-hidden="true"></svg-icon>
            <span aria-hidden="true">Drag files here or </span>
            <label [for]="uniqueId" class="file-select-label"><span role="button" class="outline-offset-1" aria-controls="'file'" tabindex="0" (keyup.enter)="chooseFileLabelClick($event)">Choose File</span></label>
          </span>
          <button class="button upload-button no-margin outline-offset-1" (click)="chooseFileLabelClick($event)"><svg-icon title="File Upload" icon="icon-upload" class="small white minor-margin-right" aria-hidden="true"></svg-icon>Upload File</button>
          <input #input type="file" [id]="uniqueId" name="file" multiple class="file-select"  (change)="addFiles($event)">
        </div>
      </div>
    </div>
  </ng-container>
  @if (showFileList) {
    @for (file of files; track file) {
      <div class="flex">
        <uploaded-file [allowFileDeletion]="allowDeletion" [file]="file" (fileDeleted)="removeFile($event)"></uploaded-file>
      </div>
    }
  }
  <confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
</div>
